function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDtIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 90.31 90.59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M80.4,6.16h-69A4.54,4.54,0,0,0,7,10.75V41.8a1.75,1.75,0,1,0,3.49,0v-31a1,1,0,0,1,1-1h69a1,1,0,0,1,1,1v69.5a1,1,0,0,1-1,1h-69a1,1,0,0,1-1-1V56A3.37,3.37,0,0,0,8.7,49.76,3.37,3.37,0,0,0,7,56v24.3a4.54,4.54,0,0,0,4.48,4.59h69a4.53,4.53,0,0,0,4.47-4.59V10.75A4.53,4.53,0,0,0,80.4,6.16Z",
    style: {
      fill: "#006098"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.61,63.35V29.72h7A8,8,0,0,1,43.72,32a9.09,9.09,0,0,1,2.1,6.42V54.14q0,4.72-2.24,7a8.69,8.69,0,0,1-6.42,2.24Zm4.7-29.1V58.82h2.17a3.43,3.43,0,0,0,2.81-1,5,5,0,0,0,.83-3.19V38.41a5.22,5.22,0,0,0-.78-3.07,3.33,3.33,0,0,0-2.86-1.09Z",
    style: {
      fill: "#0075c9"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.87,63.35V34.25H47.43V29.72H63v4.53H57.57v29.1Z",
    style: {
      fill: "#0075c9"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDtIcon);
export default __webpack_public_path__ + "static/media/dtIcon.827be90f.svg";
export { ForwardRef as ReactComponent };